export enum TelcoType {
    INTERNET = 'internet',
    LANDLINE = 'fixe',
    OPEN = 'open',
    MOBILE = 'mobile',
    MOBILE_POSTPAID = 'mobilePostpaid',
    MOBILE_PREPAID = 'mobilePrepaid',
    OBS = 'obs',
}
